<main id="main-content" class="h-screen flex flex-col pl-8 pr-4 py-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <h1 class="oswald-font text-3xl uppercase">
                Behavioral Threat Assessment Cases
            </h1>            
            <assess-assistant></assess-assistant>
        </div>
    </div>
    
    <!-- MAIN CONTENT -->
    <div class=" p-2 w-full flex flex-grow flex-col items-start overflow-y-auto">
        <div class="w-full flex items-start justify-between">
            <div class="flex items-start justify-start gap-1">
                <button 
                    *ngFor="let page of pages"
                    class="w-32 px-3 py-2 rounded-t-lg oswald-font shadow-custom-2 text-lg text-center cursor-pointer"
                    [ngClass]="{
                        'bg-white': this.selectedPage === page,
                        'bg-gradient-to-b from-nside-gray-100 to-nside-gray-200 text-white': this.selectedPage !== page
                        }"
                    (click)="$event.preventDefault(); navigateToPage(page.route); this.selectedPage = page;"
                >
                    {{ page.name }}
                </button>
            </div>
            <button
                *ngIf="this.buildingId"
                class="w-22 px-2.5 py-1 rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:from-nside-orange-100 hover:to-nside-orange-200 text-white text-lg oswald-font flex items-center justify-center gap-2"
                (click)="$event.preventDefault(); handleOpenModal('student ssid');"
            >
                <lucide-icon [img]="icons.Plus"></lucide-icon>
                Add New Case
            </button>
        </div>
        <div class="w-full max-h-full bg-white rounded-b-md rounded-tr-md shadow-custom-2 p-6 overflow-y-auto">            
            <router-outlet></router-outlet>
        </div>
    </div>

    <student-ssid
        *ngIf="this.showStudentSSIDForm"
        (onClose)="handleCloseModal('student ssid')"
        (onSubmit)="handleSubmitStudentSSID($event)"
    ></student-ssid>

    <student-info-form
        *ngIf="this.showStudentInfoForm && this.studentSSID"
        [ssidNum]="this.studentSSID"
        (onClose)="handleCloseModal('student info')"
        (onUploadCase)="handleOpenUploadCase($event)"
    ></student-info-form>

    <student-info-review
        *ngIf="this.showStudentInfoReview && this.currentStudent"
        [studentInfo]="this.currentStudent"
        (onClose)="handleCloseModal('student info review')"
        (onContinue)="handleCloseModal('student info review and continue')"
    ></student-info-review>

    <student-cases
        *ngIf="this.showStudentCases && this.currentStudent"
        [ssidNum]="this.currentStudent.student_identifier"
        (onClose)="handleCloseModal('student cases')"
        (onSubmit)="handleCreateNewCaseForExistingStudent($event)"
    ></student-cases>

    <upload-case
        *ngIf="this.uploadCaseId && this.buildingId"
        [caseId]="this.uploadCaseId"
        [buildingId]="this.buildingId"
        (onClose)="handleCloseUploadCase()"
        (onCompleted)="handleUploadedCaseCompleted($event)"
    ></upload-case>

    <popup-message 
        [type]="messageModal"
        (close)="resetMessageModal()"
        [message]="popupMessage"
    ></popup-message>
    
    <div *ngIf="loading">
        <spinner></spinner>
    </div>

</main>